import React from 'react';
import PropTypes from 'prop-types';
import Reaptcha from 'reaptcha';
import axios from 'axios';
import styled, { keyframes } from 'styled-components';
import classNames from 'classnames';
import Dropzone from 'react-dropzone';
import Button from '../_common/Button';
import Input from '../_common/Input';
import H4 from '../_common/H4';
import Textarea from '../_common/Textarea';
import { colors, fonts, media } from '../../globalStyles';
import { RECAPTCHA_SITE_KEY } from '../../config';
import gtag from '../../gtag';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const StyledForm = styled.div`
	width: 100%;
	.grecaptcha-badge {
		opacity: 0;
	}
	p {
		padding-left: 10px;
		margin: 8px 0;
		font-size: 14px;
	}

	.form-error-message {
		color: #fd4326;
		position: absolute;
		left: 12px;
		bottom: -30px;
		&.text-right {
			left: unset;
			right: 12px;
			width: 50%;
			text-align: center;
		}
	}

	.form-item {
		margin-top: 0;
		position: relative;
		&:nth-child(n + 2) {
			margin-top: 36px;
		}
	}

	*:focus {
		outline: none;
	}
	${H4} {
		color: ${colors.darkGrey};
		text-align: center;
		a {
			color: ${colors.darkGrey};
		}
	}
	.clip-button {
		padding: 0;
		position: absolute;
		right: 10px;
		top: 14px;
		width: 19px;
		height: 24px;
		background: url(data:image/svg+xml;utf8;base64,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)
			no-repeat center center;
		background-size: cover;
		cursor: pointer;
		border: none;
		.dropzone {
			width: 100%;
			height: 100%;
		}
	}

	.added-files-cover {
		margin-top: 16px;
		background-color: rgba(246, 246, 246, 0.2);
		padding: 16px;

		div {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-top: 10px;
			font-size: 16px;
			text-align: right;
			font-weight: bold;
		}
		.remove-file-button {
			margin-left: 8px;
			height: 20px;
			width: 20px;
			border: none;
			background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjEgMSA1MTEuOTk5OTggNTExLjk5OTk4IiB3aWR0aD0iMjRweCI+PHBhdGggZD0ibTI1NiAwYy0xNDEuMzg2NzE5IDAtMjU2IDExNC42MTMyODEtMjU2IDI1NnMxMTQuNjEzMjgxIDI1NiAyNTYgMjU2IDI1Ni0xMTQuNjEzMjgxIDI1Ni0yNTZjLS4xNjc5NjktMTQxLjMxNjQwNi0xMTQuNjgzNTk0LTI1NS44MzIwMzEtMjU2LTI1NnptMCA0ODBjLTEyMy43MTA5MzggMC0yMjQtMTAwLjI4OTA2Mi0yMjQtMjI0czEwMC4yODkwNjItMjI0IDIyNC0yMjQgMjI0IDEwMC4yODkwNjIgMjI0IDIyNGMtLjEzMjgxMiAxMjMuNjU2MjUtMTAwLjM0Mzc1IDIyMy44NjcxODgtMjI0IDIyNHptMCAwIiBmaWxsPSIjZmQ0MzI2Ii8+PHBhdGggZD0ibTM4MC40NDkyMTkgMTMxLjU1MDc4MWMtNi4yNS02LjI0NjA5My0xNi4zNzg5MDctNi4yNDYwOTMtMjIuNjI1IDBsLTEwMS44MjQyMTkgMTAxLjgyNDIxOS0xMDEuODI0MjE5LTEwMS44MjQyMTljLTYuMTQwNjI1LTYuMzU1NDY5LTE2LjI2OTUzMS02LjUzMTI1LTIyLjYyNS0uMzkwNjI1LTYuMzU1NDY5IDYuMTM2NzE5LTYuNTMxMjUgMTYuMjY1NjI1LS4zOTA2MjUgMjIuNjIxMDk0LjEyODkwNi4xMzI4MTIuMjU3ODEzLjI2NTYyNS4zOTA2MjUuMzk0NTMxbDEwMS44MjQyMTkgMTAxLjgyNDIxOS0xMDEuODI0MjE5IDEwMS44MjQyMTljLTYuMzU1NDY5IDYuMTM2NzE5LTYuNTMxMjUgMTYuMjY1NjI1LS4zOTA2MjUgMjIuNjI1IDYuMTM2NzE5IDYuMzU1NDY5IDE2LjI2NTYyNSA2LjUzMTI1IDIyLjYyMTA5NC4zOTA2MjUuMTMyODEyLS4xMjg5MDYuMjY1NjI1LS4yNTc4MTMuMzk0NTMxLS4zOTA2MjVsMTAxLjgyNDIxOS0xMDEuODI0MjE5IDEwMS44MjQyMTkgMTAxLjgyNDIxOWM2LjM1NTQ2OSA2LjEzNjcxOSAxNi40ODQzNzUgNS45NjA5MzcgMjIuNjIxMDkzLS4zOTQ1MzEgNS45ODgyODItNi4xOTkyMTkgNS45ODgyODItMTYuMDMxMjUgMC0yMi4yMzA0NjlsLTEwMS44MjAzMTItMTAxLjgyNDIxOSAxMDEuODI0MjE5LTEwMS44MjQyMTljNi4yNDYwOTMtNi4yNDYwOTMgNi4yNDYwOTMtMTYuMzc1IDAtMjIuNjI1em0wIDAiIGZpbGw9IiNmZDQzMjYiLz48L3N2Zz4K);
			background-size: contain;
		}
	}

	.submit-button-cover {
		margin: 60px auto 0;
		text-align: center;
		overflow: hidden;
		position: relative;
		height: 60px;
		.btn-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.btn-wrapper,
		${H4} {
			transition: all 0.5s;
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
		}
		.btn-wrapper {
			&.out {
				transform: translateY(100px);
			}
			&.in {
				transform: translateY(0);
			}
		}
		${H4} {
			&.out {
				transform: translateY(-100px);
			}
			&.in {
				transform: translateY(0);
			}
		}
		.spinner {
			margin-left: 16px;
			display: block;
			height: 32px;
			width: 32px;
			content: ' 1';
			-webkit-animation: ${rotate} 2s infinite linear;
			background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE2IDE2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNiAxNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIzMnB4IiBoZWlnaHQ9IjMycHgiPgo8Zz4KCTxwYXRoIGQ9Ik0yLjA4Myw5SDAuMDYySDB2NWwxLjQ4MS0xLjM2MUMyLjkzMiwxNC42NzMsNS4zMTEsMTYsOCwxNmM0LjA4LDAsNy40NDYtMy4wNTQsNy45MzgtN2gtMi4wMjEgICBjLTAuNDc2LDIuODM4LTIuOTQ0LDUtNS45MTcsNWMtMi4xMDYsMC0zLjk2LTEuMDg2LTUuMDMtMi43MjlMNS40NDEsOUgyLjA4M3oiIGZpbGw9IiM0MzQzNDMiLz4KCTxwYXRoIGQ9Ik04LDBDMy45MiwwLDAuNTU0LDMuMDU0LDAuMDYyLDdoMi4wMjFDMi41NTksNC4xNjIsNS4wMjcsMiw4LDJjMi4xNjksMCw0LjA3LDEuMTUxLDUuMTI0LDIuODc2ICAgTDExLDdoMmgwLjkxN2gyLjAyMUgxNlYybC0xLjQzMiwxLjQzMkMxMy4xMjMsMS4zNTcsMTAuNzIsMCw4LDB6IiBmaWxsPSIjNDM0MzQzIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
			background-size: cover;
		}
	}
	.options-list {
		padding: 0;
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		z-index: 1;
		display: none;
		&.show {
			display: block;
		}
		li {
			background-color: #fff;
			color: #676767;
			font-size: 14px;
			line-height: 30px;
			padding: 20px;
			border-top: 1px solid transparent;
			border-bottom: 1px solid transparent;
			cursor: pointer;
			&:hover {
				border-color: #cccccc;
				background: #ededed;
			}
		}
	}
	.captcha-wrapper {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		.captcha-text {
			font-size: 28px;
			font-family: ${fonts.openSansSembiBold};
			color: ${colors.blackTitle};
		}
		${Input} {
			display: inline-block;
			width: 150px;
		}
	}
	${media.maxSm`
		${Textarea} {
			height: 127px;
		}
		.form-item {
			&:nth-child(n + 2) {
				margin-top: 24px;
			}
		}
		.options-list{
			max-height: 220px;
			overflow: auto;
		}
	`}
`;
const options = [
	'Website Development',
	'Mobile Development',
	'Ecommerce Development',
	'WordPress Development',
	'Database Integration',
	'CRM/ERP Support',
	'IT consulting',
	'Blockchain Development',
	'FinTech Development',
];

const initialFormData = {
	name: '',
	email: '',
	description: '',
	category: '',
	files: [],
	errors: {},
};

class Form extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			formData: { ...initialFormData },
			showDropdown: false,
			formStatus: '',
		};
		this.recaptchaInstance = React.createRef();
	}

	handleInputChange = event => {
		const key = event.target.name;
		const value = event.target.value;
		const { formData } = this.state;
		this.setState({
			formData: {
				...formData,
				[key]: value,
				errors: {
					...formData.errors,
					[key]: false,
				},
			},
		});
	};
	handleFormSubmit = event => {
		event.preventDefault();
		if (!this.handleValidateFields()) {
			return;
		}
		this.recaptchaInstance.current.execute();
	};

	handleVerifyCaptcha = response => {
		if (response) {
			this.submitForm().catch(() => {
				console.error('Something went wrong');
			});
		}
	};

	submitForm = async () => {
		this.setState({
			formStatus: 'sending',
		});
		this.recaptchaInstance.current.reset();
		const fd = new FormData();
		if (this.state.formData.files.length > 0) {
			this.state.formData.files.forEach(file => {
				fd.append(`files`, file);
			});
		}
		fd.set('email', this.state.formData.email);
		fd.set('name', this.state.formData.name);
		fd.set('category', this.state.formData.category);
		fd.set('description', this.state.formData.description);
		try {
			await axios({
				method: 'POST',
				url: 'https://pixelteh.com/api/contact',
				data: fd,
				headers: {
					'Content-Type': `multipart/form-data`,
				},
			});
			gtag('Submit', this.props.label, 'submit');
			this.setState({
				formStatus: 'success',
				formData: { ...initialFormData },
			});
			setTimeout(() => {
				this.setState({ formStatus: '' });
			}, 3000);
		} catch {
			this.setState({ formStatus: 'error' });
		}
	};

	handleValidateFields = () => {
		const { formData } = this.state;
		let formValid = true;
		const errors = {};
		const validateKeys = this.props.contactPage
			? Object.keys(formData)
			: Object.keys(formData).filter(i => i !== 'category');
		validateKeys.map(fieldKey => {
			const val = formData[fieldKey];
			if (
				!val ||
				(fieldKey === 'email' &&
					!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(val))
			) {
				errors[fieldKey] = true;
				formValid = false;
			}
		});
		this.setState({
			formData: {
				...formData,
				errors,
			},
		});
		return formValid;
	};

	onDrop = acceptedFiles => {
		const {
			formData,
			formData: { files },
		} = this.state;
		this.setState({
			formData: {
				...formData,
				files: [...files, ...acceptedFiles],
			},
		});
	};

	removeFile = index => {
		const {
			formData,
			formData: { files },
		} = this.state;
		const outputArray = [...files];
		outputArray.splice(index, 1);
		this.setState({
			formData: {
				...formData,
				files: outputArray,
			},
		});
	};

	handleOutsideClick = e => {
		if (e.target.classList.contains('selected-option-overflow')) {
			return;
		}
		this.toggleDropdown();
	};

	toggleDropdown = () => {
		const body = document.querySelector('body');
		const eventAction = this.state.showDropdown
			? 'removeEventListener'
			: 'addEventListener';
		body[eventAction]('click', this.handleOutsideClick);
		this.setState({ showDropdown: !this.state.showDropdown });
	};

	handleDropdownClick = dropdownName => {
		this.setState({
			...this.state,
			formData: { ...this.state.formData, category: dropdownName },
		});
	};

	render() {
		const {
			formStatus,
			formData: { name, email, description, files, errors, category },
			showDropdown,
		} = this.state;

		return (
			<StyledForm>
				<form onSubmit={this.handleFormSubmit}>
					<div className="form-item">
						<Input
							type="text"
							name="name"
							className="form-control"
							placeholder="Your Name"
							value={name}
							onChange={this.handleInputChange}
						/>
						<p className="form-error-message">
							{errors.name && 'Required field'}
						</p>
					</div>
					<div className="form-item">
						<Input
							type="email"
							name="email"
							className="form-control"
							placeholder="Your Email Address"
							value={email}
							onChange={this.handleInputChange}
						/>
						<p className="form-error-message">
							{errors.email && 'Required field'}
						</p>
					</div>
					{this.props.contactPage && (
						<div className="form-item">
							<Input
								disabled
								className="selected-option"
								placeholder={options[0]}
								value={category}
							/>
							{/*eslint-disable-next-line*/}
							<span
								className="selected-option-overflow"
								onClick={this.toggleDropdown}
							/>

							<span className="arrow-triangle" />
							<ul className={`options-list ${showDropdown ? 'show' : ''}`}>
								{options.map((item, i) => (
									// eslint-disable-next-line
									<li key={i} onClick={() => this.handleDropdownClick(item)}>
										{item}
									</li>
								))}
							</ul>
						</div>
					)}
					<div className="form-item">
						<Textarea
							name="description"
							rows="10"
							cols="45"
							className="form-control"
							placeholder="Tell us about your project"
							value={description}
							onChange={this.handleInputChange}
						/>
						<p className="form-error-message">
							{errors.description && 'Required field'}
						</p>
						{!this.props.contactPage && (
							<button type="button" className="clip-button">
								<Dropzone onDrop={this.onDrop}>
									{({ getRootProps, getInputProps, isDragActive }) => {
										return (
											<div
												{...getRootProps()}
												className={classNames('dropzone', {
													'dropzone--isActive': isDragActive,
												})}
											>
												<input
													{...getInputProps()}
													className="dropDown-input"
												/>
											</div>
										);
									}}
								</Dropzone>
							</button>
						)}
					</div>
					{files.length > 0 && (
						<div className="added-files-cover">
							{files.map((fileData, index) => (
								<div key={index}>
									<p>{`${fileData.name} ${Math.floor(
										fileData.size / 1024
									)} kB`}</p>
									<button
										type="button"
										className="remove-file-button"
										onClick={() => this.removeFile(index)}
									/>
								</div>
							))}
						</div>
					)}
					<Reaptcha
						ref={this.recaptchaInstance}
						sitekey={RECAPTCHA_SITE_KEY}
						size="invisible"
						onVerify={this.handleVerifyCaptcha}
					/>
					<div className="submit-button-cover">
						<H4
							className={classNames({
								in: formStatus === 'success',
								out: formStatus !== 'success',
							})}
						>
							Thank you! We’ll get back to you shortly!
						</H4>
						<H4
							className={classNames({
								in: formStatus === 'error',
								out: formStatus !== 'error',
							})}
						>
							Something went wrong... <br />
							Please send us email to{' '}
							<a href="mailto:hi@pixelteh.com">hi@pixelteh.com</a>
						</H4>
						<div
							className={classNames({
								'btn-wrapper': true,
								out: formStatus === 'success' || formStatus === 'error',
								in: formStatus === '',
							})}
						>
							<Button
								type="submit"
								disabled={formStatus === 'sending'}
								arrow={formStatus !== 'sending' && !this.props.contactPage}
							>
								{formStatus === 'sending'
									? 'Sending...'
									: this.props.sendBtnText}
							</Button>
						</div>
					</div>
				</form>
			</StyledForm>
		);
	}
}

Form.propTypes = {
	contactPage: PropTypes.bool,
	sendBtnText: PropTypes.string,
	label: PropTypes.string.isRequired,
};
Form.defaultProps = {
	sendBtnText: 'Send Inquiry',
};

export default Form;
